import "bootstrap/dist/css/bootstrap.min.css";
import {
  BrowserRouter as Router,
  Navigate,
  Route,
  Routes,
} from "react-router-dom";
import Billing from "./pages/Billing";
import Dashboard from "./pages/Dashboard";
import Layout from "./components/Layout";
import Login from "./pages/Login";
import Numbers from "./pages/Numbers";
import React, { useState } from "react";
import Setting from "./pages/Setting";
import Spam from "./pages/Spam";

function App() {
  const [auth, setAuth] = useState(
    localStorage.getItem("auth")
      ? JSON.parse(localStorage.getItem("auth"))
      : null
  );

  const ProtectedRoute = ({ children }) => {
    return auth ? children : <Navigate replace to="/login" />;
  };

  const [isNewUserAdded, setIsNewUserAdded] = useState(false);

  return (
    <Router>
      <Routes>
        <Route
          element={
            auth ? <Navigate replace to="/" /> : <Login setAuth={setAuth} />
          }
          path="/login"
        />
        <Route
          path="*"
          element={
            <Layout isNewUserAdded={isNewUserAdded} setAuth={setAuth}>
              <Routes>
                {!auth?.user.isAdmin && (
                  <>
                    <Route
                      element={
                        <ProtectedRoute>
                          <Billing />
                        </ProtectedRoute>
                      }
                      path="/billing"
                    />
                    <Route
                      element={
                        <ProtectedRoute>
                          <Numbers />
                        </ProtectedRoute>
                      }
                      path="/numbers"
                    />
                    <Route
                      element={
                        <ProtectedRoute>
                          <Setting />
                        </ProtectedRoute>
                      }
                      path="/setting"
                    />
                  </>
                )}
                <Route
                  element={
                    <ProtectedRoute>
                      <Dashboard setIsNewUserAdded={setIsNewUserAdded} />
                    </ProtectedRoute>
                  }
                  path="/"
                />
                <Route
                  element={
                    <ProtectedRoute>
                      <Spam />
                    </ProtectedRoute>
                  }
                  path="/spam"
                />
              </Routes>
            </Layout>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
